import { gql } from '@apollo/client';
const GET_VALID_TEAM_MEMBERS = gql`
  query validTeamMembers($id: Int!, $categoryId: Int!, $tournamentId: Int, $filter: ListTeamInput) {
    validTeamMembers(id: $id, categoryId: $categoryId, tournamentId: $tournamentId, filter: $filter)
  }
`;
export default GET_VALID_TEAM_MEMBERS;
